// StatusCard.jsx
import React from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  statusCard: {
    cursor: "pointer",
    display: "flex",
    borderRadius: "12px",
    overflow: "hidden",
    height: "94px",
    backgroundColor: "#E7ECFA",
    fontFamily: "'Be Vietnam Pro', sans-serif",
    fontWeight: 500,
    position: "relative",
    width: "100%", // Ensure full width for responsiveness
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      transform: "translateY(-3px)",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    },
    [theme.breakpoints.down("xs")]: {
      height: "80px", // Slightly smaller height on mobile
    },
  },
  statusText: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    paddingLeft: "16px",
    fontSize: "16px",
    fontWeight: 200,
    color: "#494949",
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
      paddingLeft: "12px",
    },
  },
  statusValueContainer: {
    width: "38%",
    background: "linear-gradient(to right, #3159A6, #133984)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%, 10% 50%)",
    [theme.breakpoints.down("xs")]: {
      width: "42%", // Slightly wider on mobile for better visibility
    },
  },
  statusValue: {
    fontSize: "30px",
    fontWeight: "100",
    color: "#ffffff",
    fontFamily: "'Open Sans', sans-serif",
    zIndex: 2,
    [theme.breakpoints.down("xs")]: {
      fontSize: "24px",
    },
  },
}));

const StatusCard = ({ label, value, route, history }) => {
  const classes = useStyles();
  return (
    <Box
      className={classes.statusCard}
      onClick={() => route && history.push(route)}
    >
      <Typography className={classes.statusText}>{label}</Typography>
      <Box className={classes.statusValueContainer}>
        <Typography className={classes.statusValue}>
          {value.toString().padStart(2, "0")}
        </Typography>
      </Box>
    </Box>
  );
};

StatusCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  route: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
};

export default StatusCard;
